module.exports = "pegasus_template/assets/theme3/l_d.png";